/** French org-admin UI copy (sidebar, tabs, dialogs, billing tab). */

import {
  WC2026_ORG_BILLING_DISCLOSURE,
  WC2026_ORG_BILLING_DISCLOSURE_SHORT,
} from '../../../shared/constants/wc2026OrgBillingDisclosure.constants'

export const accountAdminCopyFr = {
  backToSite: '← Retour au site',
  ORG_DRAWER_PARENT_FALLBACK: 'Organisations',
  FRIENDS_ENTRY_LABEL: 'Gérer l’organisation',
  FRIENDS_ENTRY_HINT: 'Image de marque et membres',
  START_HERE: 'Commencer ici',
  START_HERE_INTRO:
    'Utilisez la navigation de l’organisation pour passer entre Commencer ici, Image de marque, Membres et Paramètres. Ensuite :',
  OPEN_MENU: 'Ouvrir le menu',
  BRANDING: 'Image de marque',
  MEMBERS: 'Membres',
  SETTINGS: 'Paramètres',
  PLAN_BILLING: 'Forfait',
  PLAN_BILLING_INTRO:
    'Mettez à niveau votre organisation sur le web, gérez les moyens de paiement et consultez les factures dans le portail client Stripe.',
  PLAN_BILLING_CURRENT: 'Forfait actuel',
  PLAN_BILLING_RENEWS: 'Renouvellement ou fin de période',
  PLAN_BILLING_STATUS: 'Statut de l’abonnement',
  PLAN_BILLING_UPGRADE_BUSINESS: 'Passer à Business',
  PLAN_BILLING_UPGRADE_ENTERPRISE: 'Passer à Enterprise',
  PLAN_BILLING_PORTAL: 'Gérer la facturation et les factures',
  PLAN_BILLING_WEB_ONLY: 'Les forfaits sont disponibles sur le web.',
  INVOICE_DETAILS: 'Facturation et facture',
  INVOICE_DETAILS_WEB_ONLY: 'Facturation et facture sont disponibles sur le web.',
  MANAGE_PLAN_BILLING: 'Gérer le forfait',
  COMPARE_PLANS: 'Comparer les forfaits',
  NO_ORG_TITLE: 'Pas encore d’organisation',
  NO_ORG_SUBTITLE: 'Créez-en une pour gérer l’image de marque et les membres, ou rejoignez avec un code.',
  CREATE_PLACEHOLDER: 'Nom de l’organisation',
  CREATE_CTA: 'Créer l’organisation',
  JOIN_PLACEHOLDER: 'Code d’adhésion',
  JOIN_CTA: 'Rejoindre',
  MEMBER_ONLY_TITLE: 'Accès membre',
  MEMBER_ONLY_MESSAGE:
    'Seuls les administrateurs de l’organisation peuvent modifier l’image de marque et les paramètres. Contactez votre administrateur si vous avez besoin de modifications.',
  MEMBER_INVITE_RETURN_TITLE: 'Vous êtes déjà dans cette organisation',
  MEMBER_INVITE_RETURN_MESSAGE:
    'Ce lien est destiné aux coéquipiers qui doivent encore rejoindre. Vous êtes connecté en tant que membre, il n’y a rien à accepter. Seuls les administrateurs peuvent modifier l’image de marque et les paramètres.',
  B2B_LOGO_MAX_COUNT: 1,
  BRAND_IMAGERY_SECTION_TITLE: 'Visuels de marque',
  UPLOAD_LOGOS: 'Téléverser le logo',
  LOGO_TILE_LABEL: 'Logo',
  LOGO_TILE_EMPTY: 'Ajouter un logo',
  BANNER_TILE_LABEL: 'Bannière du squad',
  BANNER_TILE_EMPTY: 'Ajouter une bannière',
  UPLOAD_BANNER: 'Téléverser la bannière',
  REPLACE_BANNER: 'Remplacer la bannière',
  REMOVE_BANNER: 'Supprimer la bannière',
  REMOVE_BANNER_CONFIRM_TITLE: 'Supprimer cette bannière ?',
  REMOVE_BANNER_CONFIRM_MESSAGE: 'Le squad repassera au dégradé de couleur de marque.',
  LOGOS_UPLOAD_LIMITS_PLACEHOLDER: '',
  LOGOS_UPLOAD_HINT:
    'PNG, JPG, WebP ou SVG. Max 2 Mo. Carré (1:1), 512–1024 px de côté. PNG transparent de préférence.',
  BANNER_UPLOAD_HINT:
    'PNG, JPG ou WebP. Max 2 Mo. Format 4:1 — 1600×400 px recommandé, min. 1200×300 px.',
  USE_BANNER_BACKGROUND_LABEL: 'Utiliser l’image de bannière comme arrière-plan du squad',
  USE_BANNER_BACKGROUND_HINT:
    'Lorsque activé, le hero du squad affiche votre image de bannière au lieu du dégradé des couleurs primaire/secondaire.',
  USE_BANNER_BACKGROUND_DISABLED_HINT: 'Téléversez d’abord une image de bannière pour activer cette option.',
  USE_BANNER_BACKGROUND_SAVED: 'Enregistré',
  REMOVE_LOGO: 'Supprimer',
  DOWNLOAD_LOGO: 'Télécharger',
  DOWNLOAD_LOGO_ERROR: 'Impossible de télécharger l’image',
  REMOVE_LOGO_CONFIRM_TITLE: 'Supprimer ce logo ?',
  REMOVE_LOGO_CONFIRM_MESSAGE: 'Il n’apparaîtra plus pour votre organisation.',
  LOGO_FILE_TOO_LARGE: 'Cette image dépasse la limite de 2 Mo. Essayez un fichier plus petit.',
  SAVE_COLORS: 'Enregistrer les couleurs',
  COLORS_SAVED: 'Couleurs enregistrées',
  PRIMARY: 'Primaire',
  SECONDARY: 'Secondaire',
  COLOR_PRESETS: 'Préréglages',
  COLOR_PALETTE_LABEL: 'Palette',
  COLOR_PALETTE_SATURATION_A11Y: 'Saturation et luminosité. Glissez pour choisir la couleur.',
  COLOR_PALETTE_HUE_A11Y: 'Teinte. Glissez pour modifier la couleur.',
  CUSTOM_HEX_LABEL: 'Personnalisé (hex)',
  HEX_PLACEHOLDER: '#RRGGBB',
  JOIN_CODE: 'Code d’adhésion',
  SQUAD_JOIN_CODE: 'Code d’adhésion du squad',
  ADD_MEMBERS_TITLE: 'Ajouter des coéquipiers',
  ADD_MEMBERS_BODY:
    'Partagez le lien d’invitation ci-dessous. Les coéquipiers se connectent à Zporti et ouvrent le lien pour rejoindre cette organisation.',
  ADD_MEMBERS_BODY_WC_SINGLE_PRIMARY:
    'Partagez le lien d’invitation ci-dessous pour que les coéquipiers se connectent et rejoignent cette organisation — ils sont ajoutés automatiquement à votre squad Football 2026 lié. Pour des amis hors de l’organisation, partagez une invitation au squad depuis Football 2026 → Squads (pas depuis cette page).',
  MEMBERS_DIRECTORY: 'Annuaire des membres',
  MEMBERS_ADMIN_HINT:
    'Les administrateurs peuvent gérer l’image de marque, les membres et les paramètres. Utilisez Promouvoir admin / Rétrograder / Retirer dans la colonne Actions.',
  MEMBERS_TABLE_NAME: 'Nom',
  MEMBERS_TABLE_EMAIL: 'E-mail',
  MEMBERS_TABLE_ROLE: 'Rôle',
  MEMBERS_TABLE_JOINED: 'Rejoint le',
  MEMBERS_TABLE_ACTIONS: 'Actions',
  MEMBERS_TABLE_NO_ACTIONS_VISIBLE: 'Aucune action',
  MEMBER_ACTION_LOADING_A11Y: 'Mise à jour du membre',
  MEMBERS_BULK_REMOVE_LOADING_A11Y: 'Suppression des membres sélectionnés',
  MEMBERS_TABLE_NO_ACTIONS_A11Y:
    'Aucune action. Vous ne pouvez pas modifier votre propre ligne, ou il n’y a rien à changer pour ce membre.',
  ROLE_LABEL_ADMIN: 'Administrateur',
  ROLE_LABEL_MEMBER: 'Membre',
  MEMBERS_EMPTY: 'Pas encore de membres.',
  MEMBER_ROW_YOU_INLINE: ' (Vous)',
  INVITE_LINK: 'Lien d’invitation',
  INVITE_LINK_HINT: 'Partagez ce lien pour que les coéquipiers se connectent et rejoignent votre organisation.',
  INVITE_LINK_HINT_WC:
    'Ce lien ouvre le flux d’adhésion à l’organisation. Après connexion, ils rejoignent l’org et votre squad Football 2026 lié ensemble.',
  INVITE_LINK_QR_HINT: 'Scannez avec l’appareil photo du téléphone pour ouvrir ce lien.',
  INVITE_LINK_QR_A11Y:
    'Code QR du lien d’invitation. Scannez avec l’appareil photo du téléphone pour ouvrir la page d’adhésion.',
  COPY_INVITE_LINK: 'Copier le lien',
  VIEW_LINKED_SQUAD: 'Voir la page du squad',
  VIEW_LINKED_SQUAD_A11Y: 'Ouvrir le squad Football 2026 lié pour prévisualiser les résultats',
  SEATS: 'Places',
  SEATS_UNLIMITED: 'Illimitées',
  MAKE_ADMIN: 'Promouvoir admin',
  MAKE_ADMIN_TITLE: 'Promouvoir ce membre administrateur ?',
  MAKE_ADMIN_MESSAGE:
    'Il pourra gérer l’image de marque, les membres et les paramètres de l’organisation.',
  DEMOTE_ADMIN: 'Rétrograder',
  DEMOTE_ADMIN_TITLE: 'Rétrograder cet administrateur ?',
  DEMOTE_ADMIN_MESSAGE: 'Il conservera l’accès en tant que membre mais perdra les contrôles administrateur.',
  REMOVE_MEMBER: 'Retirer',
  MEMBERS_BULK_SELECT: 'Sélection multiple',
  MEMBERS_BULK_CANCEL_SELECT: 'Annuler la sélection',
  MEMBERS_BULK_REMOVE: 'Retirer la sélection',
  MEMBERS_BULK_REMOVE_TITLE: 'Retirer les membres sélectionnés ?',
  MEMBERS_BULK_REMOVE_MESSAGE:
    'Ils perdront l’accès à cette organisation (et au squad Football 2026 lié, le cas échéant). Cette action est irréversible.',
  MEMBERS_BULK_REMOVE_CONFIRM: 'Retirer',
  MEMBERS_BULK_ROW_CHECKBOX_A11Y: 'Sélectionner le membre pour suppression groupée',
  MEMBERS_BULK_CANCEL_DIALOG: 'Annuler',
  MEMBERS_BULK_REMOVE_FAILED: 'Échec de la suppression groupée',
  MEMBERS_INVITE_LINK_COPIED: 'Lien copié',
  membersBulkRemoveSummary: (removed: number, skipped: number) =>
    `${removed} retiré(s) ; ${skipped} ignoré(s)`,
  membersBulkRemoveDone: (removed: number) => `${removed} retiré(s)`,
  MEMBERS_BULK_SELECT_ALL_A11Y: 'Sélectionner ou désélectionner tous les membres sauf vous',
  ACCOUNT_NAME: 'Nom de l’organisation',
  SAVE_NAME: 'Enregistrer le nom',
  WC_LINKED_SQUAD_SECTION_TITLE: 'Squad Football 2026 lié',
  WC_LINKED_SQUAD_SECTION_BODY_LINKED:
    'C’est le même squad que sous Football 2026 → Squads. Modifiez le nom du squad ici ou sur cet écran. Partagez le lien d’invitation de l’organisation depuis l’onglet Membres : les nouveaux membres rejoignent d’abord l’org, sont ajoutés automatiquement à ce squad, puis ouvrent le squad.',
  WC_LINKED_SQUAD_SECTION_BODY_NOT_LINKED:
    'Collez un code d’invitation de squad Football 2026 pour lier ce squad à cette organisation. Après liaison, toute personne qui rejoint via le lien d’invitation de l’organisation dans l’onglet Membres est ajoutée automatiquement au squad.',
  WC_LINKED_SQUAD_NAME_LABEL: 'Nom du squad',
  WC_LINKED_SQUAD_INVITE_CODE_LABEL: 'Code d’invitation du squad',
  WC_LINKED_SQUAD_CODE_PLACEHOLDER: 'Coller le code d’invitation du squad',
  WC_LINKED_SQUAD_SAVE_NAME: 'Enregistrer le nom du squad',
  WC_LINKED_SQUAD_LINK_SQUAD: 'Lier le squad',
  ORG_ONLY_JOIN_CODE_TITLE: 'Invitation à l’organisation',
  ORG_ONLY_JOIN_CODE_BODY:
    'Partagez le lien d’invitation pour que les personnes rejoignent d’abord l’organisation ; elles sont ajoutées automatiquement au squad et peuvent l’ouvrir depuis Football 2026 → Squads.',
  COPY_ORG_INVITE_LINK: 'Copier le lien d’invitation',
  PLAN_TIER: 'Forfait',
  MEMBERSHIP_POLICY_TITLE: 'Limite de membres',
  MEMBERSHIP_POLICY_UNLIMITED_LABEL: 'Membres illimités',
  MEMBERSHIP_POLICY_UNLIMITED_APPROVED_HELP:
    'Les adhésions illimitées par lien d’invitation sont activées pour cette organisation après approbation par Zporti.',
  MEMBERSHIP_POLICY_FROM_PLAN_HELP:
    'Votre forfait inclut des membres illimités par lien d’invitation. Aucune action requise.',
  MEMBERSHIP_POLICY_PENDING_HELP:
    'Votre demande est en attente. Zporti activera les membres illimités après examen.',
  MEMBERSHIP_POLICY_LIMITED_HELP:
    'Si décoché, les adhésions par lien d’invitation sont limitées par votre quota de places (100 par défaut sur Starter).',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_TITLE: 'Demander des membres illimités ?',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_MESSAGE:
    'Cela envoie une demande à Zporti. Nous examinerons et activerons les adhésions illimitées par lien d’invitation pour votre organisation. Vous pouvez continuer à utiliser votre quota actuel d’ici là. Envoyer la demande maintenant ?',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_CONFIRM: 'Envoyer la demande',
  MEMBERSHIP_POLICY_REQUEST_SENT: 'Demande envoyée',
  MEMBERSHIP_POLICY_CANCEL_REQUEST_LINK: 'Annuler la demande',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_TITLE: 'Annuler la demande de membres illimités ?',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_MESSAGE:
    'Cela retire votre demande en attente. Zporti sera informé de l’annulation.',
  MEMBERSHIP_POLICY_CANCEL_CONFIRM: 'Annuler la demande',
  MEMBERSHIP_POLICY_CANCEL_DONE: 'Demande annulée',
  BILLING_GATE_LOCKED_TITLE: 'Finalisez la facturation pour débloquer',
  BILLING_GATE_LOCKED_BODY:
    'Configurez le forfait de votre organisation pour accéder à l’image de marque, aux membres et aux paramètres.',
  BILLING_GATE_GO_TO_BILLING: 'Aller au forfait',
  DEACTIVATE: 'Désactiver l’organisation',
  DEACTIVATE_CONFIRM_TITLE: 'Désactiver l’organisation ?',
  DEACTIVATE_CONFIRM_MESSAGE:
    'Les membres perdront les avantages de l’organisation jusqu’à sa réactivation par le support.',
  INACTIVE_TITLE: 'Inactive',
  INACTIVE_BODY:
    'Cette organisation est désactivée. Vous pouvez la réactiver s’il s’agit d’une erreur.',
  REACTIVATE: 'Réactiver',
  REMOVE_MEMBER_TITLE: 'Retirer le membre ?',
  REMOVE_MEMBER_MESSAGE: 'Il perdra l’accès à cette organisation.',
  LEAVE_ORG_TITLE: 'Quitter cette organisation ?',
  LEAVE_ORG_MESSAGE:
    'Vous perdrez l’accès aux outils d’image de marque et de gestion des membres pour cette org. Vous pourrez ensuite en créer une autre ou en rejoindre une.',
  LEAVE_ORG_CONFIRM: 'Quitter l’organisation',
  LEAVE_ORG_MEMBER_HINT:
    'Pour ne plus bénéficier des avantages de cette organisation, vous pouvez la quitter. Votre administrateur peut vous réinviter.',
  LEAVE_ORG_DONE_TITLE: 'Vous avez quitté l’organisation',
  LEAVE_ORG_DONE_MESSAGE: 'Vous pouvez créer une nouvelle organisation ou en rejoindre une avec un code depuis cette page.',
  LEAVE_ORG_SOLE_ADMIN_HINT:
    'Vous êtes le seul administrateur. Promouvez un autre membre administrateur dans Membres, puis vous pourrez quitter.',
  DEACTIVATE_PERMANENT_DELETE_FOOTNOTE:
    'Après désactivation, une section de suppression définitive avec un champ de confirmation apparaît dans cet onglet sous Quitter l’organisation.',
  DELETE_ORG_SECTION_TITLE: 'Supprimer définitivement',
  DELETE_ORG_SECTION_BODY:
    'Cela supprime l’organisation et toutes les adhésions de nos systèmes. Saisissez la phrase exacte ci-dessous : le mot delete en minuscules, un espace, puis le nom de votre organisation exactement tel qu’enregistré.',
  DELETE_ORG_NAME_LABEL: 'Saisissez cette phrase exactement',
  DELETE_ORG_BUTTON: 'Supprimer l’organisation définitivement',
  DELETE_ORG_DIALOG_TITLE: 'Supprimer cette organisation définitivement ?',
  DELETE_ORG_DIALOG_MESSAGE:
    'Cette action est irréversible. Tous les membres perdront l’accès et les données de marque seront supprimées.',
  setupGuide: {
    TITLE: 'Ordre de configuration suggéré',
    LINE_BRANDING_BEFORE: 'Définissez vos ',
    LINE_BRANDING_LINK: 'logos et couleurs de marque',
    LINE_BRANDING_AFTER: ' pour que les membres reconnaissent votre organisation.',
    LINE_MEMBERS_BEFORE: 'Invitez votre équipe depuis ',
    LINE_MEMBERS_AFTER: ' en utilisant votre lien d’invitation ou code d’adhésion.',
    LINE_SETTINGS_BEFORE: 'Vérifiez le nom de l’organisation et le forfait dans ',
    LINE_SETTINGS_AFTER: '.',
  },
  navShort: {
    START_HERE: 'Début',
    BRANDING: 'Marque',
    MEMBERS: 'Membres',
    SETTINGS: 'Réglages',
    PLAN_BILLING: 'Forfait',
    INVOICE_DETAILS: 'Facturation',
  },
  navLockedA11ySuffix: ' — finalisez la facturation pour débloquer',
  brandingPreview: {
    SECTION_LABEL: 'Aperçu',
    SQUAD_PLACEHOLDER_NAME: 'Votre escouade',
    COMPANY_NAME_PLACEHOLDER: 'Votre organisation',
    COLOR_PRIMARY_LABEL: 'Couleur principale',
    COLOR_SECONDARY_LABEL: 'Couleur secondaire',
    HERO_BACK_LABEL: 'Escouades',
    HERO_COMPANY_GROUP_LABEL: 'Groupe entreprise',
    HERO_EMPLOYEES_LABEL: 'membres',
  },
  sso: {
    TITLE: 'Connexion entreprise (SSO)',
    BODY:
      'Restreignez cette organisation aux utilisateurs d’un domaine e-mail d’entreprise spécifique. Une fois activé, les nouveaux membres qui se connectent avec Google via ce domaine sont ajoutés automatiquement — sans lien d’invitation. Les membres existants ne sont pas affectés.',
    CHECKBOX_LABEL: 'Restreindre au domaine e-mail d’entreprise',
    DOMAIN_PLACEHOLDER: 'acme.com',
    SAVE_BUTTON: 'Enregistrer les paramètres SSO',
    INVALID_DOMAIN: 'Saisissez un domaine valide (p. ex. acme.com)',
    domainRestricted: (domain: string) => `Domaine restreint à @${domain}`,
    DOMAIN_REMOVED: 'Restriction de domaine supprimée',
    SAVE_FAILED: 'Impossible d’enregistrer les paramètres SSO',
  },
  billing: {
    ORGANIZATION_PLAN_LABEL: 'Forfait organisation',
    PLAN_PICKER_HEADING: 'Choisissez votre forfait',
    PLAN_PICKER_SUBHEADING:
      'Accès organisation WC 2026 unique — image de marque, sièges membres et équipe liée pour la période du tournoi.',
    PLAN_BUSINESS_NAME: 'Business',
    PLAN_BUSINESS_PRICE: 'À partir de 450 $',
    PLAN_BUSINESS_TAGLINE:
      'Frais org unique en libre-service. Choisissez votre palier de sièges et payez une fois pour l’accès tournoi WC 2026.',
    ORG_BILLING_DISCLOSURE: WC2026_ORG_BILLING_DISCLOSURE,
    ORG_BILLING_DISCLOSURE_SHORT: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    PLAN_BUSINESS_CTA: 'Commencer',
    PLAN_ENTERPRISE_NAME: 'Enterprise',
    PLAN_ENTERPRISE_PRICE: 'Sur mesure',
    PLAN_ENTERPRISE_TAGLINE:
      'Tarification personnalisée pour les grandes organisations. Contactez-nous et nous construirons un forfait adapté.',
    PLAN_ENTERPRISE_CTA: 'Nous contacter',
    CUSTOM_FORM_NAME_LABEL: 'Votre nom',
    CUSTOM_FORM_NAME_PLACEHOLDER: 'Jane Smith',
    CUSTOM_FORM_EMAIL_LABEL: 'E-mail professionnel',
    CUSTOM_FORM_EMAIL_PLACEHOLDER: 'jane@company.com',
    CUSTOM_FORM_MESSAGE_LABEL: 'Message (facultatif)',
    CUSTOM_FORM_MESSAGE_PLACEHOLDER: 'Parlez-nous de votre organisation et de vos besoins.',
    CUSTOM_FORM_SUBMIT: 'Envoyer la demande',
    CUSTOM_FORM_SENT: 'Nous vous recontacterons bientôt !',
    PERSONAL_PLAN_LABEL: 'Forfait personnel',
    ENTERPRISE_QUOTE_LABEL: 'Prix Enterprise convenu',
    MANAGE_PORTAL: 'Gérer la facturation de l’organisation',
    MANAGE_PERSONAL_PORTAL: 'Gérer l’abonnement personnel',
    COMPARE_PLANS: 'Comparer les forfaits',
    SUBSCRIPTION_STATUS: 'Statut de l’abonnement',
    PERIOD_END: 'Renouvellement ou fin de période',
    PERSONAL_BILLING_SECTION: 'Abonnement personnel',
    ORG_BILLING_SECTION: 'Abonnement organisation',
    STRIPE_NOT_CONFIGURED:
      'La facturation est en cours de configuration. Les détails du forfait seront bientôt disponibles.',
    B2B_BILLING_RETURN_SYNCING: 'Application de votre paiement Stripe…',
    B2B_BILLING_RETURN_SYNCING_A11Y: 'Application de votre paiement Stripe',
    ORG_SEAT_TIER_LABEL: 'Palier de places',
    ORG_CURRENT_SEAT_TIER_LABEL: 'Palier de places actuel',
    UPGRADE_SEAT_TIER: 'Mettre à niveau',
    SEAT_TIER_UPGRADE_DIALOG_TITLE: 'Mettre à niveau le palier de places ?',
    SEAT_TIER_UPGRADE_DIALOG_CONFIRM: 'Continuer vers le paiement',
    SEAT_TIER_UPGRADE_DIALOG_CANCEL: 'Annuler',
    SEAT_TIER_UPGRADE_DIALOG_CURRENT_PREFIX: 'Palier de places actuel :',
    SEAT_TIER_UPGRADE_DIALOG_TARGET_PREFIX: 'Mise à niveau vers :',
    SEAT_TIER_UPGRADE_DIALOG_REFUND_BODY:
      'Vous avez déjà payé pour votre palier de places actuel (inférieur). Stripe créditera ou remboursera la portion inutilisée de ce montant pour cette mise à niveau, le paiement reflétant ainsi le montant net (prorata).',
    SEAT_TIER_UPGRADE_DIALOG_SCOPE_REMINDER: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    SEAT_TIER_UPGRADE_DIALOG_CONTINUE_PROMPT: 'Continuer ?',
    NEED_CUSTOM_PLAN: 'Besoin d’un forfait sur mesure ?',
    NEED_CUSTOM_PLAN_A11Y: 'Forfait sur mesure',
    PLAN_TIER_STARTER: 'Starter (gratuit)',
    PLAN_TIER_PRO: 'Pro',
    PLAN_TIER_BUSINESS: 'Business',
    PLAN_TIER_ENTERPRISE: 'Enterprise',
    SUBSCRIPTION_STATUS_ACTIVE: 'Active',
    SUBSCRIPTION_STATUS_TRIALING: 'Essai',
    SUBSCRIPTION_STATUS_PAST_DUE: 'En retard',
    SUBSCRIPTION_STATUS_CANCELED: 'Annulée',
    SUBSCRIPTION_STATUS_UNPAID: 'Impayée',
    SUBSCRIPTION_STATUS_INCOMPLETE: 'Incomplète',
    SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED: 'Expirée',
    SUBSCRIPTION_STATUS_PAUSED: 'En pause',
  },
} as const
